import { isComponentFor } from "Shared/resolve-component";
export default (currentPage) => {
    return (isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Checkout.Pages.Checkout.CheckoutPageViewModel"));
};
export function componentNameIsCheckoutPage(componentName) {
    return (isComponentFor(componentName, "Avensia.Shop.Features.Checkout.Pages.Checkout.CheckoutPageViewModel"));
}
